import { Contract, CostCenter, Id, Reason } from 'src/types'
import api, { make, Response } from '.'

export const PAGE_SIZE = 10

export function getCostCenters({
  organization_id,
  search
}: {
  organization_id: Id
  search: string
}): Promise<Response<CostCenter[]>> {
  return make<{ cost_centers: CostCenter[] }, CostCenter[]>({
    axiosCall: api.get(
      `/organizations/${organization_id}/resources/cost_centers?page_size=100&search=${search}`
    ),
    transformData: data => data.cost_centers
  })
}

export function getReasons({
  organization_id
}: {
  organization_id: Id
}): Promise<Response<Reason[]>> {
  return make<{ reasons: Reason[] }, Reason[]>({
    axiosCall: api.get(
      `/organizations/${organization_id}/resources/reasons?page_size=20`
    ),
    transformData: data => data.reasons
  })
}

//to find standardContract
export function getContracts({
  organization_id
}: {
  organization_id: Id
}): Promise<Response<Contract[]>> {
  return make<{ contracts: Contract[] }, Contract[]>({
    axiosCall: api.get(
      `/organizations/${organization_id}/resources/contracts?page_size=1`
    ),
    transformData: data => data.contracts
  })
}
